import api from './api'

export const productVariantsService = {
  getAll: () => api.get('/api/product-variants'),
  
  getById: (id) => api.get(`/api/product-variants/${id}`),
  
  getByProduct: (productId) => api.get(`/api/products/${productId}/variants`),
  
  create: (data) => api.post('/api/product-variants', data),
  
  update: (id, data) => api.put(`/api/product-variants/${id}`, data),
  
  delete: (id) => api.delete(`/api/product-variants/${id}`),
  
  bulkCreate: (productId, variants) => api.post(`/api/products/${productId}/variants/bulk`, {
    productId,
    variants
  })
}
